import { createHttpAction } from '@securitize/ui-components';
import { GET_AGREEMENT_BY_PULL_NEXT, GET_AGREEMENT_NEXT } from './actionTypes';

export const getAgreement = (opportunityId, options) => createHttpAction(GET_AGREEMENT_NEXT(opportunityId), {}, options)
  .action;

export const getAgreementByPull = (opportunityId, options) => createHttpAction(GET_AGREEMENT_BY_PULL_NEXT(opportunityId),
  {}, options).action;
